export function isPWAInstalled() {
    const isStandaloneIOS = window.navigator.standalone;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
    const isMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
    const isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);
    let isStandaloneSamsung = false;
    if (isSamsungBrowser) {
        const screenHeight = window.screen.height || 0;
        const innerHeight =
            window.innerHeight || document.documentElement.clientHeight || 0;
        const heightDifference = Math.abs(screenHeight - innerHeight);
        // check the isStandalone by checking the height difference between the screen height and the inner height
        if (heightDifference < 50) {
            isStandaloneSamsung = true;
        }
    }
    if (isStandaloneIOS || isStandalone || isFullscreen || isMinimalUI || isStandaloneSamsung) {
        return true;
    }
    return false;
}